/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type VerifyOrder_viewer$ref = any;
export type routes_VerifyOrder_QueryVariables = {|
  encryptedIds?: ?$ReadOnlyArray<string>
|};
export type routes_VerifyOrder_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: VerifyOrder_viewer$ref
  |}
|};
export type routes_VerifyOrder_Query = {|
  variables: routes_VerifyOrder_QueryVariables,
  response: routes_VerifyOrder_QueryResponse,
|};
*/


/*
query routes_VerifyOrder_Query(
  $encryptedIds: [String!]
) {
  viewer {
    ...VerifyOrder_viewer
    id
  }
}

fragment VerifyOrder_viewer on Customer {
  salesOrders(first: 1, encryptedIds: $encryptedIds) {
    edges {
      node {
        id
        name
        verified
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "encryptedIds"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_VerifyOrder_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VerifyOrder_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_VerifyOrder_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "encryptedIds",
                "variableName": "encryptedIds"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "SalesOrderConnection",
            "kind": "LinkedField",
            "name": "salesOrders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesOrderEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesOrder",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "verified",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e6aa82744b3ad5ddb520da862fae8faf",
    "id": null,
    "metadata": {},
    "name": "routes_VerifyOrder_Query",
    "operationKind": "query",
    "text": "query routes_VerifyOrder_Query(\n  $encryptedIds: [String!]\n) {\n  viewer {\n    ...VerifyOrder_viewer\n    id\n  }\n}\n\nfragment VerifyOrder_viewer on Customer {\n  salesOrders(first: 1, encryptedIds: $encryptedIds) {\n    edges {\n      node {\n        id\n        name\n        verified\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3685760bce23691a7b4ce3ab8fce1fb1';

module.exports = node;
